import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconScorecard(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M17 13a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0v-3ZM12 7a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1ZM9 11a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0v-5Z"
        fill="currentColor"
      />
      <path
        d="M3.9 3h16.2c.4 0 .9.4.9.9v16.2c0 .4-.5.9-.9.9H3.9c-.5 0-.9-.5-.9-.9V3.9c0-.5.4-.9.9-.9ZM5 19h14V5H5v14Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
